import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import { MixpanelService } from "../../services/mixpanel.service";
import { RouterLinksService } from "./../../services/router-links.service";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "[app-header]",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @Input() mobileIcon = false;
  @Input() mobile = false;
  @Input() resizeMenu = false;

  menuList = [
    {
      icon: "#ic-home",
      link: "/",
      title: "Início",
    },
    {
      icon: "#ic-bid",
      link: "/leiloes",
      title: "Leilões",
    },
    {
      icon: "#ic-gear",
      link: "/como-funciona",
      title: "Como Funciona",
    },
    {
      icon: "#ic-coin",
      link: "/lote/cadastrar",
      title: "Quero Vender",
    },
    {
      icon: "#ic-handHeart",
      link: "/quem-somos",
      title: "Quem somos",
    },
    {
      icon: "#ic-glasses",
      link: "/os-especialistas",
      title: "Especialistas",
    },
  ];
  mobileMenuOpen = false;

  constructor(private routerLinksService: RouterLinksService, private mixpanel: MixpanelService) { }

  ngOnInit(): void { }

  openCloseMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  setRoute(path: string): void {
    this.routerLinksService.setRouteScroll(path, 1700);
  }

  onMobileMenuClick(page: any): void {
    this.mixpanel.track(`Botão Mobile | ${page.title}`, {
      rota: page.link,
      origem: "header-mobile"
    });

    this.mobileMenuOpen = false;

    if (page.link) {
      this.setRoute(page.link);
    }
  }
}
